module.exports = __webpack_public_path__ + "img/icon_AirDrop.fd1b4070.svg";